import React, { useContext, RefObject } from 'react'
import MenuContext from 'context/menu/MenuContext'

const useObjectHover = (
  objectRef: RefObject<HTMLElement>,
  message?: string
) => {
  const showMenu = useContext(MenuContext)
  const onHover = () => {
    const object = objectRef.current
    if (!object || !message) return

    const onLeave = () => {
      clearTimeout(timeout)
      object.removeEventListener('mouseleave', onLeave)
      showMenu()
    }

    const generateHover = () => {
      const sizes = object.getBoundingClientRect()
      showMenu(<div
        className='playground__cloud'
        style={{
          left: `${sizes.left + (sizes.width / 2)}px`,
          top: `${sizes.top - 5}px`
        }}
        dangerouslySetInnerHTML={{ __html: message }}
      />)
    }

    const timeout = setTimeout(generateHover, 500)
    object.addEventListener('mouseleave', onLeave)
  }

  return onHover
}

export default useObjectHover